import type { FetchNearbyLocationsConfig, LocationsQueryParams } from "./types";

const DEFAULT_CONFIG = {
  apiEndpoint: "/api/fawkes/geo-search",
};

/**
 * Nearby locations fetcher
 */
async function fetchNearbyLocations(
  { location, radius = 30, withJobs = true }: LocationsQueryParams,
  { apiEndpoint }: FetchNearbyLocationsConfig = DEFAULT_CONFIG,
) {
  if (!location || location.trim() === "") {
    throw new Error("Location is required");
  }

  const searchParams = new URLSearchParams({
    miles: radius.toString(),
    query: location,
    withJobs: withJobs.toString(),
  });

  let result;
  try {
    const response = await fetch(`${apiEndpoint}?${searchParams}`);

    if (!response.ok) {
      throw new Error(
        `Failed to fetch nearby locations: ${response.status} ${response.statusText}`,
      );
    }

    result = await response.json();
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching nearby locations");
  }

  if (!result.success) {
    throw new Error(result.message || "Error fetching locations");
  }

  return result.data;
}

export { fetchNearbyLocations };
